module.exports = __webpack_public_path__ + "static/logo-c10466b7394f5a8968c0dda09633cfec.svg";